// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YWd52UeJBTolOklCPABw{text-decoration:none}`, "",{"version":3,"sources":["webpack://./src/pages/workflows/ui/WorkflowButtons/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,oBAAA","sourcesContent":[".helpButton {\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpButton": `YWd52UeJBTolOklCPABw`
};
export default ___CSS_LOADER_EXPORT___;
